import { atom } from "jotai";

export const allowParallelPrefetchAtom = atom(true);
